export default __webpack_public_path__ + "static/media/downButtonWhite.a39d67ca.svg";